export * from './MealPreferenceIconLabel/MealPreferenceIconLabel';
